export default class uiSelectChoiceExtended {
    constructor() {
        return {
            controller:
                ['$scope', '$element', '$attrs', '$parse', (scope, element, attrs, $parse) => {
                    let onScrolled = event => {
                        let element = event.target;
                        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                            $parse(attrs['onScrolledToBottom'])(scope);
                        }
                    };

                    element.on('scroll', onScrolled);

                    let dropDownStatusWatcher = scope.$watch('$select.open', function(newVal, oldVal) {
                        if (oldVal !== newVal && !newVal) {
                            $parse(attrs['onClosed'])(scope);
                        }
                    });

                    let searchStatusWatcher = scope.$watch('$select.search', function(newVal, oldVal) {
                        if (oldVal !== newVal) {
                            $parse(attrs['onSearched'])(scope);
                        }
                    });

                    scope.$on('$destroy', () => {
                        element.off('scroll', onScrolled);
                        dropDownStatusWatcher();
                        searchStatusWatcher();
                    });
                }]
        }
    }
}
